import React from "react";
import classNames from "classnames";

import styles from "./Wrapper.module.css";

export function Wrapper({ children, center, horizontal, style }) {
  return (
    <div
      className={classNames(styles.Container, center && styles.center)}
      style={style}
    >
      <ul className={classNames(styles.List, horizontal && styles.horizontal)}>
        {children}
      </ul>
    </div>
  );
}
